import axios from 'axios'
import {API_URL} from '../utils/consts'
import {sleep} from '../utils/sleep'

export class AuctionService {
    static async fetchMonetization(id) {
        try {
            const {data: {record: monetization}} = await axios.get(
                `${API_URL}/monetization/${id}`,
                {headers: {'content-type': 'application/json'}}
            )
            await sleep(1000)
            return monetization
        } catch (e) {
            throw e
        }
    }

    static async bid(id, payload) {
        return await axios.post(`${API_URL}/monetization/${id}/bid`, payload, {headers: {'content-type': 'application/json'}})
    }
}
